import { keyframes } from 'styled-components';
export var rotate = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
export var fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);